import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BaseResponse } from "../../typings/interfaces";
import { BaseResponseSingle } from "../../typings/interfaces/responses";
import { IPriceOverrideConfigResponse } from "../../typings/interfaces/responses/priceOverrideConfigResponse";
import { IPriceOverrideConfigRequest } from "../../typings/interfaces/requests/priceOverrideConfigRequest";
import {
    GET_ALL_PRICE_OVERRIDE_CONFIGS,
    GET_ACTIVE_PRICE_OVERRIDE_CONFIGS,
    CREATE_PRICE_OVERRIDE_CONFIG,
    UPDATE_PRICE_OVERRIDE_CONFIG,
    DELETE_PRICE_OVERRIDE_CONFIG,
} from "../../configs/apiConfig";

export const getAllPriceOverrideConfigsAction = createAsyncThunk(
    "priceOverrideConfig/get-all",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get<BaseResponse<IPriceOverrideConfigResponse>>(
                GET_ALL_PRICE_OVERRIDE_CONFIGS
            );
            return response.data;
        } catch (err) {
            if (!err) {
                throw err;
            }
            return rejectWithValue(err);
        }
    }
);

export const getActivePriceOverrideConfigsAction = createAsyncThunk(
    "priceOverrideConfig/get-active",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get<BaseResponse<IPriceOverrideConfigResponse>>(
                GET_ACTIVE_PRICE_OVERRIDE_CONFIGS
            );
            return response.data;
        } catch (err) {
            if (!err) {
                throw err;
            }
            return rejectWithValue(err);
        }
    }
);

export const createPriceOverrideConfigAction = createAsyncThunk(
    "priceOverrideConfig/create",
    async (request: IPriceOverrideConfigRequest, { rejectWithValue }) => {
        try {
            const response = await axios.post<BaseResponseSingle<IPriceOverrideConfigResponse>>(
                CREATE_PRICE_OVERRIDE_CONFIG,
                request
            );
            return response.data;
        } catch (err) {
            if (!err) {
                throw err;
            }
            return rejectWithValue(err);
        }
    }
);

export const updatePriceOverrideConfigAction = createAsyncThunk(
    "priceOverrideConfig/update",
    async (request: IPriceOverrideConfigRequest, { rejectWithValue }) => {
        try {
            const response = await axios.put<BaseResponseSingle<IPriceOverrideConfigResponse>>(
                UPDATE_PRICE_OVERRIDE_CONFIG,
                request
            );
            return response.data;
        } catch (err: any) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const deletePriceOverrideConfigAction = createAsyncThunk<
    boolean,
    number
>(
    "priceOverrideConfig/delete",
    async (id, { rejectWithValue }) => {
        try {
            await axios.delete(DELETE_PRICE_OVERRIDE_CONFIG(id));
            return true;
        } catch (err: any) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);
